import { useEffect, useState } from "react";
import { ArrowDown } from "lucide-react";

const HERO_SLIDES = [
    "https://i.ibb.co/c7hn2XN/trokay.jpg",
    "https://i.ibb.co/Ng1WDFyH/trokay-3.jpg",
    "https://i.ibb.co/fY4gtRtN/trokay-11.jpg",
    "https://i.ibb.co/nM0Fxw1h/trokay-49.jpg",
];

export default function Hero() {
    const [slide, setSlide] = useState(0);

    useEffect(() => {
        const id = setInterval(() => setSlide((s) => (s + 1) % HERO_SLIDES.length), 4500);
        return () => clearInterval(id);
    }, []);

    const goAbout = () => document.getElementById("o-vinarstvi")?.scrollIntoView({ behavior: "smooth" });

    return (
        <section
            id="uvod"
            data-testid="hero-section"
            className="relative min-h-[100svh] w-full overflow-hidden pt-28 md:pt-32 pb-12 md:pb-20 px-6 md:px-12"
        >
            <div className="mx-auto max-w-[1500px] grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
                <div className="lg:col-span-7 lg:pr-8 relative z-10">
                    <p className="overline mb-8 fade-in">Rodinné vinařství · Prušánky · Morava</p>
                    <h1 className="font-serif font-medium text-[3.5rem] sm:text-7xl lg:text-[8.5rem] leading-[0.92] tracking-[-0.02em] text-ink fade-in fade-in-delay-1">
                        Vinařství
                        <br />
                        <span className="font-serif-italic text-burgundy">Štrokay</span>
                    </h1>
                    <div className="mt-10 flex items-start gap-6 max-w-xl fade-in fade-in-delay-2">
                        <div className="hidden md:block w-12 h-px bg-burgundy mt-3 shrink-0" />
                        <p className="text-base md:text-lg leading-relaxed text-ink2">
                            Víno, degustace a ubytování pod jednou střechou.
                            Tradice, kterou již osm generací píše charakter
                            <span className="text-ink"> našeho kraje</span>.
                        </p>
                    </div>
                    <div className="mt-10 flex flex-wrap gap-4 fade-in fade-in-delay-3">
                        <button data-testid="hero-cta-wines" className="btn-burgundy"
                            onClick={() => document.getElementById("vina")?.scrollIntoView({ behavior: "smooth" })}>
                            Naše vína
                        </button>
                        <button data-testid="hero-cta-stay" className="btn-outline"
                            onClick={() => document.getElementById("ubytovani")?.scrollIntoView({ behavior: "smooth" })}>
                            Ubytování
                        </button>
                    </div>
                </div>

                {/* single big slideshow */}
                <div className="lg:col-span-5 relative h-[480px] md:h-[680px] fade-in fade-in-delay-2 image-hover overflow-hidden">
                    {HERO_SLIDES.map((src, i) => (
                        <img
                            key={src}
                            src={src}
                            alt="Vinařství Štrokay"
                            loading={i === 0 ? "eager" : "lazy"}
                            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1600ms] ease-in-out ${slide === i ? "opacity-100" : "opacity-0"}`}
                        />
                    ))}
                    <div className="absolute bottom-5 left-5 flex gap-1.5 z-10" data-testid="hero-slide-dots">
                        {HERO_SLIDES.map((_, i) => (
                            <button
                                key={i}
                                data-testid={`hero-dot-${i}`}
                                onClick={() => setSlide(i)}
                                aria-label={`fotka ${i + 1}`}
                                className={`h-1 transition-all duration-500 ${slide === i ? "w-10 bg-cream" : "w-2.5 bg-cream/60 hover:bg-cream/90"}`}
                            />
                        ))}
                    </div>
                </div>
            </div>

            <div className="hidden lg:block absolute right-8 top-32 font-serif-italic text-burgundy/20 text-[10rem] leading-none pointer-events-none select-none">
                est.
            </div>

            <button data-testid="hero-scroll-indicator" onClick={goAbout}
                className="absolute left-6 md:left-12 bottom-10 flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-ink2 hover:text-burgundy transition-colors group">
                <span>Posunout dolů</span>
                <ArrowDown size={14} className="group-hover:translate-y-1 transition-transform" />
            </button>

            <div className="absolute right-6 md:right-12 bottom-10 hidden md:flex items-baseline gap-3 text-ink2">
                <span className="text-xs uppercase tracking-[0.25em]">Od</span>
                <span className="font-serif-italic text-3xl text-burgundy">1820</span>
            </div>
        </section>
    );
}
